export function setResposta(state,payload) {
  state.resposta = payload;
}